import React from 'react';
import PropTypes from 'prop-types';

import { Switch, Route } from 'react-router-dom';

import RefundRequestsStats from './organization/refund-requests';
import PageError from '../error/pageError';

export default function OrganizationStats({ organization, path }) {
    return (
        <Switch>
            <Route exact path={`${path}/refund-requests`} render={({ history }) => <RefundRequestsStats organization={organization} history={history} />} />
            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

OrganizationStats.propTypes = {
    organization: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired
};
